<template>
  <div class="playerBox notranslate" :class="{noData: !hasVoice}">
    <audio-player
      ref="audioPlayer"
      :show-prev-button="false"
      :show-next-button="false"
      :show-volume-button="false"
      :show-progress-bar="false"
      :show-playback-rate="false"
      :isLoop="false"
      :theme-color="color"
      :audio-list="audio" />
    <div v-if="filteredList && filteredList.length > 1" class="trigger" @click="clickAudio"></div>
    <div v-if="!hasVoice" class="trigger"></div>
    <div v-if="selectVoice" class="layer voiceLayer">
      <div class="inner">
        <h2 class="layerTitle">{{locale.select_voice_language}}</h2>
        <div class="voiceList">
          <div class="checkbox radio"
            v-for="voice in filteredList"
            :key="voice.lang">
            <input type="radio"
              :value="voice.lang"
              :id="`voice_${voice.lang}`"
              name="voice_lang"
              @change="setSelectVoice(voice.lang)">
            <label :for="`voice_${voice.lang}`" class="btn btnWhite btnFull">{{voice.lang}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioPlayer from '@liripeng/vue-audio-player'

export default {
  name: 'SmartVoice',
  props: [
    'locale',
    'id',
    'setting'
  ],
  components: {
    AudioPlayer
  },
  computed: {
    lang () {
      return this.$route.params.ln
    },
    color () {
      const hex = this.setting && this.setting.colorHex && this.setting.colorHex.active
      return hex ? this.setting.colorHex.color : '#000000'
    },
    filteredList () {
      const lang = this.lang
      const siteid = this.$store.state.authentication.site
      const langKey = `${siteid}_${lang}_voice`
      const filtered = this.list.filter(x => {
        const conversion = x.lang.replace('cmn', 'zh').replace('nb', 'no') // 중국어 zh-CN -> tts cmn-CN / 노르웨이어 no -> tts nb
        return getLang(conversion) === lang
      })
      const defaultVoice = this.defaultVoice || 'en'
      const defaultVoiceData = this.list.filter((x, i) => {
        return x.lang === defaultVoice
      })
      function getLang (langLocale) {
        return langLocale.includes('zh')
          ? langLocale
          : langLocale.split('-')[0] // 중국어만 zh-CN/zh-TW, 나머지는 언어만 리턴
      }
      return filtered.length === 0
        ? defaultVoiceData.length === 0
          ? this.list.filter((x, i) => i === 0)
          : defaultVoiceData
        : filtered.filter(x => x.lang === localStorage.getItem(langKey)).length === 0
          ? filtered
          : filtered.filter(x => x.lang === localStorage.getItem(langKey))
    },
    audio () {
      return this.filteredList ? Object.values(this.filteredList.map(x => x.fileUri)) : []
    },
    auidoLang () {
      return this.filteredList ? Object.values(this.filteredList.map(x => x.lang)) : []
    }
  },
  watch: {
  },
  created () {
    const groupId = this.setting.smartvoice.id
    const lang = this.lang
    this.$store.dispatch('smartvoice/getGroups').then((group) => {
      if (group && group.find(x => x.groupId === groupId)) {
        this.defaultVoice = group.find(x => x.groupId === groupId).defaultVoice || lang
        this.hasVoice = true
      } else {
        // 설정된 음성 정보를 찾지 못했습니다.
        alert(this.locale.alert_smartvoice_fail)
      }
    })
    this.$store.dispatch('smartvoice/getSmartVoice', groupId).then((res) => {
      // res: voice list
      this.list = res
    })
  },
  data () {
    return {
      hasVoice: false,
      defaultVoice: '',
      list: [],
      selectVoice: false
    }
  },
  methods: {
    clickAudio (e) {
      if (this.filteredList.length > 1) {
        this.$emit('setPopover', this.id)
        this.selectVoice = true
      }
    },
    setSelectVoice (voice) {
      const lang = this.lang
      const siteid = this.$store.state.authentication.site
      const v = this.list.find(x => x.lang === voice)
      this.audio = v && v.fileUri
      localStorage.setItem(`${siteid}_${lang}_voice`, voice)
      this.selectVoice = false
    }
  }
}
</script>

<style lang="scss" scoped>
.voiceLayer {
  .layerTitle {
    padding-right: 0;
    text-align: center;
  }
  .inner {
    align-items: center;
    justify-content: center;
    color: $color-white;
    background: none;
  }
  .voiceList {
    width: 300px;
    max-height: 100%;
    margin: 0 auto;
    border-radius: 4px;
    background-color: $color-white;
    overflow: auto;
    .btn {
      padding: 1em 1em 1em 40px;
      &:before {
        top: 50%;
        left: 1em;
        margin-top: -10px;
      }
    }
    .checkbox {
      display: block;
      margin: 0;
      & + .checkbox .btn {
        border-top: none;
      }
    }
  }
}
</style>
